var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2424 11.1717H9.09981C7.97949 11.1717 7.07129 12.0799 7.07129 13.2002V19.2858C7.07129 20.4061 7.97949 21.3143 9.09981 21.3143H19.2424C20.3627 21.3143 21.2709 20.4061 21.2709 19.2858V13.2002C21.2709 12.0799 20.3627 11.1717 19.2424 11.1717Z",
    stroke: "#636874",
    strokeWidth: 2.02852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1711 17.257C14.7313 17.257 15.1854 16.8029 15.1854 16.2428C15.1854 15.6826 14.7313 15.2285 14.1711 15.2285C13.611 15.2285 13.1569 15.6826 13.1569 16.2428C13.1569 16.8029 13.611 17.257 14.1711 17.257Z",
    stroke: "#636874",
    strokeWidth: 2.02852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11 11.1716V7.11455C3.11 6.03856 3.53744 5.00663 4.29828 4.24579C5.05912 3.48495 6.09105 3.05751 7.16704 3.05751C8.24304 3.05751 9.27496 3.48495 10.0358 4.24579C10.7966 5.00663 11.2241 6.03856 11.2241 7.11455V11.1716",
    stroke: "#636874",
    strokeWidth: 2.02852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3422,
    height: 24.3422,
    fill: "white",
    transform: "translate(0 0.0146484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockLock);
export default __webpack_public_path__ + "static/media/unlock-lock.b67ae9ab23b3cec0d104b21b50191f02.svg";
export { ForwardRef as ReactComponent };